import ReferentListPagingResultModelBase from '../_generated/modelBases/referent-list-paging-result-model-base';

export default class ReferentListPagingResultModel extends ReferentListPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
